import axios, { AxiosPromise } from 'axios';
import { IGoogleCloudStorage } from '../@types/model/googleCloudStorage/googleCloudStorage';

export default class GoogleCloudStorageHttpService {
    public static getListData(path : string) : AxiosPromise<Array<any>> {
        return axios.get(`${API_URL}/v1/GoogleCloudStorage?path=${path}`);
    }

    public static downloadFile(path : string, fileName : string) : AxiosPromise<string> {
        return axios.get(`${API_URL}/v1/GoogleCloudStorage/DownloadFile`, {
            params: {
                fileName,
                path,
            },
        });
    }

    public static uploadFile(data : Array<IGoogleCloudStorage>) : AxiosPromise<any> {
        return axios.post(`${API_URL}/v1/GoogleCloudStorage/PostGoogleCloudStorage`, data);
    }

    public static deleteFile(path : string, fileName : string) : AxiosPromise<any> {
        return axios.delete(`${API_URL}/v1/GoogleCloudStorage/DeleteFile`, {
            params: {
                fileName,
                path,
            },
        });
    }
}
